// Übersetzungen für die Module, wie I18n in PHP: Geschrieben wird Deutsch, der
// deutsche Text ist zugleich der Schlüssel. Für andere Sprachen bettet das
// Layout den Katalog translations/<sprache>/js.php als JSON ein (#i18n); auf
// Deutsch gibt es keinen. Platzhalter in geschweiften Klammern:
// t('{done} von {total} geprüft', { done: 1, total: 3 }). Mehrzahl:
// tn('{count} Zugang|{count} Zugänge', n) - die erste Form gilt für genau eins.
let catalog = null;

function messages() {
  if (catalog === null) {
    const block = document.getElementById('i18n');
    try {
      catalog = block ? JSON.parse(block.textContent) : {};
    } catch (e) {
      catalog = {};
    }
  }
  return catalog;
}

function lookup(text) {
  const key = text.replace(/\s+/g, ' ').trim();
  return Object.prototype.hasOwnProperty.call(messages(), key) ? messages()[key] : key;
}

function replace(text, params) {
  if (!params) return text;
  return text.replace(/\{(\w+)\}/g, function (match, name) {
    return Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match;
  });
}

export function t(text, params) {
  return replace(lookup(text), params);
}

export function tn(text, count, params) {
  const forms = lookup(text).split('|');
  const form = count === 1 || forms.length < 2 ? forms[0] : forms[1];
  return replace(form, Object.assign({ count: count }, params));
}
